export { TimepickerConfig } from './timepicker.config';
export { TimepickerComponent } from './timepicker.component';
export { TimepickerModule } from './timepicker.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/ng2-bootstrap/timepicker/index.js
// module id = ../../../../ng2-bootstrap/timepicker/index.js
// module chunks = 4